import React from "react";
import { Container, Row, Col, Card, CardBody, CardHeader, Button, CardFooter, Modal, Form, ModalBody } from 'react-bootstrap';
import TopNavbar from "../Components/TopNavbar";
import EpsFooter from "../Components/EpsFooter";
import ReactMarkdown from 'react-markdown'
import axios from 'axios';
import HubspotContactForm from "../Components/HubspotContactForm";
import '../App.css';

class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            paslaugos: [
                {
                    name: "Svetainių kūrimas",
                    shortdescription: "internetinės svetainės kūrimas, atitinkantis kliento poreikius ir tikslus.",
                    description: "Internetin\u0117s svetain\u0117s k\u016Brimas, atitinkantis kliento poreikius ir tikslus.\r\nK\u0105 mes galime padaryti u\u017E jus?\r\n\r\n   - Sukursime jums unikali\u0105 ir patraukli\u0105 svetain\u0119, atitinkan\u010Di\u0105 j\u016Bs\u0173 verslo poreikius.\r\n   - Pad\u0117sime jums pritraukti daugiau klient\u0173 ir padidinti pardavimus.\r\n   - Teiksime jums vis\u0105 reikiam\u0105 palaikym\u0105 ir konsultacijas.",
                    image: "/img/tinklapiu_kurimas.jpg._sm.jpg",
                    id: "svetainiu-kurimas"
                },
                {
                    name: "El. parduotuvių kūrimas",
                    shortdescription: "internetinių parduotuvių kūrimas, padedantis verslui parduoti prekes ir paslaugas internetu.",
                    description: "El. parduotuv\u0117 yra puikus b\u016Bdas verslui parduoti savo prekes ar paslaugas internetu. Ji leid\u017Eia verslui pasiekti didesn\u0119 auditorij\u0105 ir padidinti pardavimus.\r\n\r\n**M\u016Bs\u0173 el. parduotuvi\u0173 k\u016Brimo paslaugos apima:**\r\n\r\n- **Koncepcijos k\u016Brimas:** kartu su jumis sukursime el. parduotuv\u0117s koncepcij\u0105, atitinkan\u010Di\u0105 j\u016Bs\u0173 verslo poreikius.\r\n- **Dizainas:** sukursime el. parduotuv\u0117s dizain\u0105, kuris bus patrauklus j\u016Bs\u0173 klientams.\r\n- **Programavimas:** sukursime el. parduotuv\u0119, kuri veiks skland\u017Eiai ir efektyviai.\r\n- **Testavimas:** kruop\u0161\u010Diai i\u0161testuosime el. parduotuv\u0119, kad u\u017Etikrintume jos kokyb\u0119.\r\n- **Pristatymas:** pristatysime el. parduotuv\u0119 ir apmokysime, kaip ja naudotis.\r\n\r\n**M\u016Bs\u0173 el. parduotuvi\u0173 k\u016Brimo specialistai turi didel\u0119 patirt\u012F ir \u017Eini\u0173 \u0161ioje srityje. Mes naudojame naujausias technologijas ir metodus, kad sukurtume auk\u0161tos kokyb\u0117s el. parduotuves.**\r\n\r\n**Kod\u0117l verta rinktis m\u016Bs\u0173 el. parduotuvi\u0173 k\u016Brimo paslaugas:**\r\n\r\n- **Patirtis ir \u017Einios:** M\u016Bs\u0173 specialistai turi didel\u0119 patirt\u012F ir \u017Eini\u0173 \u0161ioje srityje.\r\n- **Auk\u0161tos kokyb\u0117s darbas:** Mes naudojame naujausias technologijas ir metodus, kad sukurtume auk\u0161tos kokyb\u0117s el. parduotuves.\r\n- **Konkurencingos kainos:** M\u016Bs\u0173 kainos yra konkurencingos rinkoje.\r\n\r\n**Susisiekite su mumis jau \u0161iandien, kad su\u017Einotum\u0117te daugiau apie m\u016Bs\u0173 el. parduotuvi\u0173 k\u016Brimo paslaugas!**",
                    image: "/img/eshop.jpg._sm.jpg",
                    id: "eshop-kurimas"
                },
                {
                    name: "Tinklapių ir informacinių sistemų palaikymas",
                    shortdescription: "svetainių ir informacinių sistemų palaikymas, užtikrinantis jų sklandų veikimą ir saugumą.",
                    description: "Tinklapiai ir informacin\u0117s sistemos yra svarbi bet kurios \u012Fmon\u0117s veiklos dalis. Jie leid\u017Eia verslui bendrauti su klientais, parduoti prekes ar paslaugas, valdyti procesus ir dar daugiau.\r\n\r\n**M\u016Bs\u0173 tinklapi\u0173 ir informacini\u0173 sistem\u0173 palaikymo paslaugos apima:**\r\n\r\n- **Kryptini\u0173 prieigos paslaugos:** u\u017Etikrinsime, kad j\u016Bs\u0173 tinklapiai ir informacin\u0117s sistemos b\u016Bt\u0173 saugios nuo \u012Fsilau\u017Eim\u0173 ir kit\u0173 gr\u0117smi\u0173.\r\n- **Programin\u0117s \u012Frangos atnaujinimai:** u\u017Etikrinsime, kad j\u016Bs\u0173 tinklapiai ir informacin\u0117s sistemos b\u016Bt\u0173 atnaujintos naujausiomis versijomis.\r\n- **Problem\u0173 sprendimas:** greitai ir efektyviai i\u0161spr\u0119sime visas j\u016Bs\u0173 tinklapi\u0173 ir informacini\u0173 sistem\u0173 problemas.\r\n- **Naujienos ir patarimai:** informuosime jus apie naujausias technologijas ir tendencijas, kad gal\u0117tum\u0117te pagerinti savo tinklapi\u0173 ir informacini\u0173 sistem\u0173 veikim\u0105.\r\n\r\n**M\u016Bs\u0173 tinklapi\u0173 ir informacini\u0173 sistem\u0173 palaikymo specialistai turi didel\u0119 patirt\u012F ir \u017Eini\u0173 \u0161ioje srityje. Mes naudojame naujausias technologijas ir metodus, kad u\u017Etikrintume j\u016Bs\u0173 tinklapi\u0173 ir informacini\u0173 sistem\u0173 skland\u0173 veikim\u0105.**\r\n\r\n**Kod\u0117l verta rinktis m\u016Bs\u0173 tinklapi\u0173 ir informacini\u0173 sistem\u0173 palaikymo paslaugas:**\r\n\r\n- **Patirtis ir \u017Einios:** M\u016Bs\u0173 specialistai turi didel\u0119 patirt\u012F ir \u017Eini\u0173 \u0161ioje srityje.\r\n- **Auk\u0161tos kokyb\u0117s darbas:** Mes naudojame naujausias technologijas ir metodus, kad u\u017Etikrintume j\u016Bs\u0173 tinklapi\u0173 ir informacini\u0173 sistem\u0173 skland\u0173 veikim\u0105.\r\n- **Konkurencingos kainos:** M\u016Bs\u0173 kainos yra konkurencingos rinkoje.\r\n\r\n**Susisiekite su mumis jau \u0161iandien, kad su\u017Einotum\u0117te daugiau apie m\u016Bs\u0173 tinklapi\u0173 ir informacini\u0173 sistem\u0173 palaikymo paslaugas!**",
                    image: "/img/palaikymas.jpg._sm.jpg",
                    id: "tinklapiu-palaikymas"
                },
                {
                    name: "Saugumo spragų tikrinimas",
                    shortdescription: "Tinklapių ir informacinių sistemų saugumo spragų tikrinimas, bei konsultacijos jas taisant.",
                    description: "Tinklapių ir informacinių sistemų saugumo spragų tikrinimas, bei konsultacijos jas taisant.",
                    image: "/img/pentesting.jpg._sm.jpg",
                    id: "saugumo-tikrinimas"
                },
                {
                    name: ".NET programavimas",
                    shortdescription: "Programinės įrangos kurimas pagal jūsų verslo poreikius",
                    description: ".NET yra populiarus programavimo karkasas, naudojamas \u012Fvairi\u0173 tip\u0173 program\u0173 k\u016Brimui, \u012Fskaitant web, mobili\u0173j\u0173 \u012Frengini\u0173 ir Windows aplikacijas. Jis si\u016Blo plat\u0173 funkcionalum\u0105 ir bibliotek\u0173 rinkin\u012F, kuris palengvina programavimo proces\u0105.\r\n\r\n**M\u016Bs\u0173 .NET programavimo paslaugos apima:**\r\n\r\n- **Naujos programin\u0117s \u012Frangos k\u016Brimas:** sukuriame .NET aplikacijas pagal j\u016Bs\u0173 individualius poreikius.\r\n- **Esamos programin\u0117s \u012Frangos tobulinimas:** atnaujiname ir tobuliname j\u016Bs\u0173 esam\u0105 .NET programin\u0119 \u012Frang\u0105, kad ji b\u016Bt\u0173 efektyvesn\u0117 ir patikimesn\u0117.\r\n- **Programin\u0117s \u012Frangos prie\u017Ei\u016Bra ir palaikymas:** teikiame prie\u017Ei\u016Br\u0105 ir palaikym\u0105 j\u016Bs\u0173 .NET programinei \u012Frangai, kad ji visada veikt\u0173 skland\u017Eiai.\r\n\r\n**M\u016Bs\u0173 .NET programuotojai turi didel\u0119 patirt\u012F ir \u017Eini\u0173 \u0161ia programavimo kalba. Mes naudojame naujausias technologijas ir metodus, kad sukurtume auk\u0161tos kokyb\u0117s .NET programin\u0119 \u012Frang\u0105.**\r\n\r\n**Susisiekite su mumis, kad su\u017Einotum\u0117te daugiau apie m\u016Bs\u0173 .NET programavimo paslaugas.**",
                    image: "/img/dotnet_programavimas.jpg._sm.jpg",
                    id: "dotnet-programavimas"
                },
                {
                    name: "Kryptovaliutų integracija ir konsultavimas",
                    shortdescription: "Integruojame kryptovaliutų mokėjimų sistemas į klientų tinklalapius ir el. parduotuves, kad jie galėtų priimti mokėjimus iš klientų visame pasaulyje.",
                    description: "K\u0105 mes galime padaryti u\u017E jus?\r\n\r\n   - Pad\u0117sime sukurti ir administruoti kryptovaliut\u0173 pinigines.\r\n   - Pad\u0117sime integruoti kryptovaliut\u0173 mok\u0117jimus \u012F j\u016Bs\u0173 tinklap\u012F ar el. parduotuv\u0119.\r\n   - Konsultuosime visais su kryptovaliutomis susijusiais klausimais.\r\n\r\nSusisiekite su mumis jau \u0161iandien, kad su\u017Einotum\u0117te daugiau apie m\u016Bs\u0173 paslaugas!",
                    image: "/img/crypto.jpg._sm.jpg",
                    id: "kryptovaliutos"
                },
            ],
            modal: false,
            name: "",
            email: "",
            service: "",
            notes: ""
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }

    handleSubmit(event) {
        event.preventDefault();

        let formData = {
            name: this.state.name,
            email: this.state.email,
            service: this.state.service,
            notes: this.state.notes
        }

        axios.post("/Form.php", formData).then(function (response) {

        }).catch(error => {

        });

        this.setState({ modal: false });

    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    render() {

        const pageStyle = {
            backgroundImage: "url(background_hd.jpg)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            color: "white",
            overflowY: "scroll"
        };

        return (
            <Container fluid style={pageStyle}>
                <TopNavbar />
                <Container>
                    <Row className="home-banner">
                        <Col></Col>
                        <Col lg="7" md="9" xs="12" >
                            <h1><strong>EPSILON PLIUS</strong> - patikimas jūsų verslo partneris informacinių technologijų srityje</h1>
                        </Col>
                        <Col></Col>
                    </Row>
                    <Row>
                        <i className="fa-brands fa-square-js"></i>
                    </Row>
                    <Row>
                        {this.state.paslaugos.map((item, index) => (
                            <Col md="4" key={index}>
                                <a href={"#" + item.id} className="card-link">
                                    <Card className="page-card card-h-1 card-hover top-2">
                                        <CardHeader style={{ textAlign: "center" }}>
                                            <h4>{item.name}</h4>
                                        </CardHeader>
                                        <CardBody>
                                            <p>{item.shortdescription}</p>
                                        </CardBody>
                                    </Card>
                                </a>
                            </Col>
                        ))}
                    </Row>
                    <Container>
                        <div className="block-title">
                            <h2>Paslaugos</h2>
                        </div>
                        {this.state.paslaugos.map(paslauga => (
                            <Row style={{ marginTop: "2vh" }}>
                                <Card className="page-card" id={paslauga.id}>
                                    <CardHeader>
                                        <h3>{paslauga.name}</h3>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col md="6" xs="12">
                                                <img src={paslauga.image} width="100%" />
                                            </Col>
                                            <Col>
                                                <ReactMarkdown>{paslauga.description}</ReactMarkdown>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                    <CardFooter>
                                        <Button variant="outline-light" onClick={() => this.setState({ modal: true })}>Susisiekti</Button>
                                    </CardFooter>
                                </Card>
                            </Row>
                        ))}
                    </Container>
                    <Modal
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        show={this.state.modal}
                    >
                        {/* <Card className="page-card">
                            <CardHeader>
                                <Row>
                                    <Col md="11" style={{ textAlign: "center" }}>
                                        <h3>Gauti pasiūlymą</h3>
                                    </Col>
                                    <Col md="1"><Button variant="outline-light" onClick={() => this.setState({ modal: false })}>X</Button></Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <HubspotContactForm></HubspotContactForm>
                            </CardBody>
                        </Card> */}

                        <Card className="page-card">
                            <CardHeader>
                                <Row>
                                    <Col md="11" style={{ textAlign: "center" }}>
                                        <h3>Gauti pasiūlymą</h3>
                                    </Col>
                                    <Col md="1"><Button variant="outline-light" onClick={() => this.setState({ modal: false })}>X</Button></Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Group className="mb-3" controlId="contactName">
                                        <Form.Label>Vardas/Pavadinimas*</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Vardas/Pavadinimas"
                                            name="name"
                                            required
                                            onChange={this.handleInputChange}
                                            value={this.state.name} />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="contactEmail">
                                        <Form.Label>El. paštas*</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="El. paštas"
                                            required
                                            name="email"
                                            onChange={this.handleInputChange}
                                            value={this.state.email}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="contactService">
                                        <Form.Label>Paslauga*</Form.Label>
                                        <Form.Control as="select"
                                            onChange={this.handleInputChange}
                                            value={this.state.service}
                                            name="service"
                                        >
                                            {this.state.paslaugos.map((item, index) => (
                                                <option value={item.id}>{item.name}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="contactNotes"
                                    >
                                        <Form.Label>Pastabos</Form.Label>
                                        <Form.Control as="textarea" rows={3} onChange={this.handleInputChange}
                                            value={this.state.notes} name="notes" />
                                    </Form.Group>
                                    <Form.Group>
                                        <hCaptcha sitekey="923481d7-79b7-4856-9b1c-6a17826e4ed6" onVerify={this.onVerifyCaptcha} />
                                    </Form.Group>
                                    <Button type="submit" variant="outline-light">Gauti pasiūlymą</Button>
                                </Form>
                            </CardBody>
                        </Card>
                    </Modal>
                    <EpsFooter />
                </Container>
            </Container >
        );
    }
}

export default Home;